import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { admlog_count, admlog_page} from '../../components/apipath';

function Admlog() {
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [logList, setLogList] = useState([]);

    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${admlog_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setLogList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    


    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${admlog_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("logList 更新後:", logList); // 確認資料是否正確被設置
    }, [logList]);


    // const fetchData = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await axios.get(`${admlog}`, {
    //             headers: { token: token }
    //         });
    //         setLogs(response.data.data || []);
    //     } catch (error) {
    //         console.error('取得日誌失敗：', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     fetchData();
    // }, []);

    return (
        <div className="container mt-4 text-center">
            <h2>後台操作紀錄</h2>
            {loading ? (
                <p>載入中...</p>
            ) : (
                <table className="table table-bordered table-striped mt-3">
                    <thead>
                        <tr>
                            <th>時間</th>
                            <th>管理員 ID</th>
                            <th>操作</th>
                            <th>資料表</th>
                            <th>目標 ID</th>
                            <th>描述</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logList.length > 0 ? (
                            logList.map((logList, i) => (
                                <tr key={i}>
                                    <td>{new Date(logList.created_at).toLocaleString()}</td>
                                    <td>{logList.admin_name || logList.admin_id}</td>
                                    <td>{logList.action}</td>
                                    <td>{logList.target_table || `${logList.target_table} #${logList.target_id}`}</td>
                                    <td>{logList.target_id}</td>
                                    <td>{logList.description}</td>
                                    <td>{logList.ip_address}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">目前沒有操作紀錄</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default Admlog;
